/**
 * Empty-state marks, exported from the canonical directory frames — the cup from
 * WEB 9, the waves from WEB 10, the network from WEB 11. Figma bakes the stroke
 * at #AAAAAA/40%, which is the "border" slot; these take currentColor
 * instead so the colour comes from a token.
 *
 * The cup is drawn on a 32 grid and the other two on 24, as the file has them.
 */

import type React from "react";

interface EmptyStateMarkProps {
  readonly className?: string;
}

export function CoffeeCupMark({
  className,
}: EmptyStateMarkProps): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22.6667 15.4667V20C22.6667 24.4183 19.0849 28 14.6667 28H12C7.58172 28 4 24.4183 4 20V15.4667C4 15.0248 4.35817 14.6667 4.8 14.6667H21.8667C22.3085 14.6667 22.6667 15.0248 22.6667 15.4667Z" />
      <path d="M16 12C16 10.6667 16.9524 9.33333 18.8572 9.33333C20.9611 9.33333 22.6667 7.62775 22.6667 5.52381V4.66667" />
      <path d="M10.6667 12V11.3333C10.6667 9.1242 12.4575 7.33333 14.6667 7.33333C16.1395 7.33333 17.3333 6.13943 17.3333 4.66667V4" />
      <path d="M21.3333 14.6667H24.6667C26.5076 14.6667 28 16.1591 28 18C28 19.8409 26.5076 21.3333 24.6667 21.3333H22.6667" />
    </svg>
  );
}

export function WavesMark({
  className,
}: EmptyStateMarkProps): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 10C5.48276 10 7.34483 7 7.34483 7C7.34483 7 9.2069 10 11.6897 10C14.1724 10 16.6552 7 16.6552 7C16.6552 7 19.1379 10 21 10" />
      <path d="M3 17C5.48276 17 7.34483 14 7.34483 14C7.34483 14 9.2069 17 11.6897 17C14.1724 17 16.6552 14 16.6552 14C16.6552 14 19.1379 17 21 17" />
    </svg>
  );
}

export function NetworkMark({
  className,
}: EmptyStateMarkProps): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M11.7 1.1732C11.8856 1.06603 12.1144 1.06603 12.3 1.17321L21.2263 6.3268C21.4119 6.43397 21.5263 6.63205 21.5263 6.84641V17.1536C21.5263 17.3679 21.4119 17.566 21.2263 17.6732L12.3 22.8268C12.1144 22.934 11.8856 22.934 11.7 22.8268L2.77372 17.6732C2.58808 17.566 2.47372 17.3679 2.47372 17.1536V6.84641C2.47372 6.63205 2.58808 6.43397 2.77372 6.32679L11.7 1.1732Z" />
      <path d="M17 15H7L12 7L17 15Z" />
      <path d="M2.5 6.5L12 7" />
      <path d="M2.5 6.5L7 15" />
      <path d="M21.5 6.5L17 15" />
      <path d="M21.5 6.5L12 6.99995V1" />
      <path d="M21.5 17.5L17 15" />
      <path d="M2.5 17.5L7 15" />
      <path d="M7 15L12 23L17 15" />
    </svg>
  );
}
